// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1YKLl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1a-MV","obliqueLine":"membershipbadge_obliqueLine__Upf44"};